<script>
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';

import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';

export default {
  name: 'LinkPay',
  props: ['booking'],

  data: () => ({
    errorMessage: '',
    disabled: false,
    loading: false,
    VerifyPaychoiceDialog: false,
    verification_received: false,
    loadingPayMethod: false,
    VerifyDialog: false,
    payDialog: false,
    verifyRadio: 'auto',
    payRadio: 'auto',
    payLoading: false,
    user: [],
    manualPayDisabled: false,
    linkVerifyInfoClicked: false,
    manualVerifyInfoClicked: false,
    successDialog: false,
  }),

  components: {
    Loader: () => import('@/components/loaders/stitchReturnLoader.vue'),
    PaystackButton: () => import('@/components/payments/paystackButton.vue'),
  },

  methods: {
    refresh() {
      this.$router.go();
    },
    paySuccess() {
      //set loading
      // this.$store.commit('setLoading', true);

      // const functions = getFunctions();

      // const verifyPaystackPayment = httpsCallable(
      //   functions,
      //   'verifyPaystackPayment'
      // );
      // // connectFunctionsEmulator(functions, 'localhost', 5001);

      // verifyPaystackPayment({
      //   ref: this.booking.id,
      // }).then((result) => {
      //   // Read result of the Cloud Function.
      //   /** @type {any} */
      //   const data = result.data;
      //   console.log('data', data);

      //   if (!data.error) {
      //     window.location.replace(data, '_self');
      //   }
      //   // if data comes back as error object then redirect to error page
      //   if (data.error) {
      //     if (
      //       data.error.response.errors[0].extensions.code ==
      //       'INTERNAL_SERVER_ERROR'
      //     ) {
      //       this.errorMessage = 'STITCH INTERNAL SERVER ERROR';
      //       this.$emit('erorr', this.errorMessage);
      //       this.error = true;
      //       this.$store.commit('setError', this.errorMessage);
      //       this.$store.commit('setLoading', false);
      //     }
      //     console.log('data', data.error.response.errors[0].extensions.code);
      //     console.log('error');
      //     this.errorMessage = 'Error: Could not create new linking URL';
      //     this.$emit('erorr', this.errorMessage);
      //     this.error = true;
      //     this.$store.commit('setError', this.errorMessage);
      //     this.$store.commit('setLoading', false);
      //   }

      //   if (data === null || !data) {
      //     this.errorMessage = 'Error: Could not create new linking URL';
      //     this.$emit('erorr', this.errorMessage);
      //     this.error = true;
      //     this.$store.commit('setError', this.errorMessage);
      //     this.$store.commit('setLoading', false);
      //   }
      // });

      this.loading = true;
      this.payDialog = false;
      this.$store
        .dispatch('updateBookingData', {
          id: this.booking.id,
          status: 'awaiting-images',
        })
        .then(() => {
          this.loading = false;
          // this.$store.commit('setLoading', false);
          this.successDialog = true;
        });
    },

    closeVerifyPaychoiceDialog() {
      this.VerifyPaychoiceDialog = false;
      this.VerifyDialog = false;
      this.loadingPayMethod = false;
    },
    async NextVerify() {
      //get selected radio button
      console.log('radio', this.verifyRadio);
      this.loading = true;

      if (this.verifyRadio == 'auto') {
        this.loading = false;
        this.infoDialog = true;
      } else if (this.verifyRadio == 'manual') {
        console.log(this.booking);
        this.$router.push({
          name: `Verify 📊`,
          params: { booking: this.booking },
        });
      }
    },
    async NextPay() {
      if (this.payRadio == 'auto') {
        this.InitiateFunctionsPaymentRequest();
      } else if (this.payRadio == 'manual') {
        this.requestPayEmail();
      } else if (this.payRadio == 'paystack') {
        this.loadingPayMethod = true;
        this.VerifyPaychoiceDialog = true;
      }
    },
    closePayDialog() {
      this.payDialog = false;
      this.loadingPayMethod = false;
      this.loadingPayMethod = false;
    },
    async requestPayEmail() {
      if (!this.user.manual_verification_received) {
        this.$router.push({
          name: `Verify 📊`,
          params: { booking: this.booking },
        });
        console.log('redirecting to verify');
      } else if (this.user.manual_verification_received) {
        console.log('create pay request email');
        this.payLoading = true;

        const db = getFirestore();
        const manualRef = doc(db, 'manual_payment', this.booking.id);

        const functions = getFunctions();

        const createVerificationLinkingUrl = httpsCallable(
          functions,
          'createVerificationLinkingUrl'
        );
        // connectFunctionsEmulator(functions, 'localhost', 5001);

        createVerificationLinkingUrl({
          email: this.$store.state.user.email,
          firstName: this.user.firstName,
          phoneNumber: this.$store.state.user.phoneNumber,
          userId: this.user.id,
          bookingId: this.booking.id,
          booking: this.booking,
        }).then((result) => {
          // Read result of the Cloud Function.
          /** @type {any} */
          const data = result.data;
          console.log('data', data);

          if (!data.error) {
            window.location.replace(data, '_self');
          }
          // if data comes back as error object then redirect to error page
          if (data.error) {
            if (
              data.error.response.errors[0].extensions.code ==
              'INTERNAL_SERVER_ERROR'
            ) {
              this.errorMessage = 'STITCH INTERNAL SERVER ERROR';
              this.$emit('erorr', this.errorMessage);
              this.error = true;
              this.$store.commit('setError', this.errorMessage);
              this.$store.commit('setLoading', false);
            }
            console.log('data', data.error.response.errors[0].extensions.code);
            console.log('error');
            this.errorMessage = 'Error: Could not create new linking URL';
            this.$emit('erorr', this.errorMessage);
            this.error = true;
            this.$store.commit('setError', this.errorMessage);
            this.$store.commit('setLoading', false);
          }

          if (data === null || !data) {
            this.errorMessage = 'Error: Could not create new linking URL';
            this.$emit('erorr', this.errorMessage);
            this.error = true;
            this.$store.commit('setError', this.errorMessage);
            this.$store.commit('setLoading', false);
          }
        });

        setDoc(manualRef, {
          userId: this.$store.state.user.id,
          bookingId: this.booking.id,
          status: 'pending',
          booking: this.booking,
        }).then(() => {
          console.log('Document successfully updated!');

          this.loading = false;
          this.payDialog = false;
          this.successDialog = true;
        });

        await this.$store.dispatch('updateBookingData', {
          id: this.booking.id,
          manual_payreq_received: true,
        });
      }
    },
    async paychoice() {
      this.loadingPayMethod = true;
      const db = getFirestore();
      const userRef = doc(db, 'users', this.$store.state.user.id);
      const userSnap = await getDoc(userRef);
      console.log('userSnap', userSnap.data());

      const user = userSnap.data();

      this.user = user;

      if (
        user.manual_verification_received ||
        user.stitch_verification_received
      ) {
        this.verification_received = true;
        this.loadingPayMethod = false;
        this.payDialog = true;
        if (this.booking.borrower_manual_payreq_received) {
          this.manualPayDisabled = true;
        }
      } else if (
        !user.stitch_verification_received &&
        !user.manual_verification_received
      ) {
        this.VerifyDialog = true;
        this.loadingPayMethod = false;
        this.verification_received = false;
      }
    },
  },
};
</script>

<template>
  <div class="grid">
    <!-- <div class="grid">
      <Loader v-if="loading" />
    </div> -->

    <v-btn
      @click="paychoice()"
      elevation="6"
      large
      block
      class="ml-n3 ma-1 appbutton rounded-lg white--text font-weight-medium"
      color="#B22AF0"
      z-index="12"
      v-if="errorMessage === ''"
      :loading="loadingPayMethod"
    >
      <!-- <v-img
        class="mr-2"
        contain
        max-height="35"
        max-width="120"
        :src="require('@/assets/logos/stitch.svg')"
        :lazy-src="require('@/assets/logos/stitch.svg')"
      /> -->
      <base-img
        :src="require('@/assets/logos/icon1.svg')"
        contain
        max-height="35"
        max-width="35"
      />
      Pay R
      <span>{{ booking.total }}</span>
    </v-btn>

    <v-dialog
      v-model="payDialog"
      max-width="550px"
      max-height="120%"
      persistent
      style="border-radius: 16px"
    >
      <v-card max-height="110%">
        <div v-if="payLoading" class="grid">
          <Loader />
        </div>
        <div class="grid" v-else-if="!payLoading">
          <!-- <v-row>
            <v-card class="mr-5" style="border-radius: 12px">
              <base-img
                :src="require('@/assets/logos/icon1.svg')"
                class="mx-auto pa-6"
                contain
                width="32"
              />
            </v-card>
          </v-row> -->
          <v-divider></v-divider>
          <v-card-title class="text-center mt-4">Strapp payment</v-card-title>

          <v-card-text class="text-md-body-2 text-caption text-center">
            Strapp Verification and payment through Stitch or through an
            alternative manual process.
          </v-card-text>

          <v-btn to="/faq" target="_blank" class="text-app" small
            >Learn more
            <v-icon small class="ml-1">mdi-open-in-new</v-icon></v-btn
          >

          <v-radio-group v-model="payRadio" column>
            <v-card class="pa-4 ma-4" outlined>
              <v-radio value="paystack">
                <template v-slot:label>
                  <p class="body-2">
                    <paystack-button
                      @paySuccess="paySuccess()"
                      :booking="booking"
                    />
                  </p> </template
              ></v-radio>
            </v-card>
            <v-card
              class="pa-4 ma-4 mt-n2 mb-n8"
              outlined
              :color="this.manualPayDisabled ? 'grey lighten-3' : ''"
            >
              <v-radio
                :disabled="this.manualPayDisabled"
                label="Manual Payment and Verification"
                value="manual"
              >
                <template v-slot:label>
                  <div v-if="!user.manual_verification_received">
                    <p class="caption">
                      <strong class="body-2 font-weight-bold">
                        Manual Payment and Verification
                        <v-icon
                          small
                          @click="
                            manualVerifyInfoClicked = !manualVerifyInfoClicked
                          "
                          >mdi-information</v-icon
                        >
                        <br />
                      </strong>
                      Manual Payment via payfast link email
                      <span v-if="manualVerifyInfoClicked"
                        ><br />This will allow you to upload your verification
                        documents manually <br />and then you will receive a
                        payfast payment link via email.</span
                      >
                      <br />
                    </p>
                  </div>
                  <div v-if="user.manual_verification_received">
                    <p class="caption">
                      <strong class="body-2 font-weight-bold">
                        Manual Payment Request
                        <v-icon
                          small
                          @click="
                            manualVerifyInfoClicked = !manualVerifyInfoClicked
                          "
                          >mdi-information</v-icon
                        >
                        <br />
                      </strong>
                      Manual Payment via payfast link email
                      <span v-if="manualVerifyInfoClicked"
                        ><br />This will request a manual payfast payment
                        link.</span
                      >
                      <br />
                    </p></div></template
              ></v-radio>
            </v-card>
          </v-radio-group>
          <hr />
        </div>
        <v-card-actions class="d-flex justify-space-between mx-12 mt-4">
          <v-btn large color="blue darken-1" text @click="closePayDialog()">
            Close
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            large
            color="accent darken-1"
            :loading="payLoading"
            text
            @click="NextPay()"
          >
            Pay <v-icon class="ml-2" medium>mdi-page-next-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="VerifyDialog"
      persistent
      max-width="550px"
      style="border-radius: 16px"
    >
      <v-card scrollable>
        <v-overlay v-if="loading" class="grid pa-12"> </v-overlay>
        <div class="grid pt-12">
          <v-row>
            <v-card class="mr-5" style="border-radius: 12px">
              <base-img
                :src="require('@/assets/logos/icon1.svg')"
                class="mx-auto pa-6"
                contain
                width="12"
              />
            </v-card>
          </v-row>
          <v-divider></v-divider>
          <v-card-title class="text-center mt-4"
            >Verification and payment</v-card-title
          >

          <v-card-text class="text-caption text-center">
            For your own safety and the safety of fellow Strappers you are
            required to verify your profile before any bookings can be
            finalized.
          </v-card-text>

          <router-link to="/faq" target="_blank" class="text-app" small
            ><p class="caption text-underline">Learn more</p>
          </router-link>

          <v-radio-group class="mt-n4" v-model="verifyRadio" column>
            <v-card class="pa-4 ma-4" outlined>
              <v-radio value="auto">
                <template v-slot:label>
                  <p class="body-2">
                    <span class="body-2 font-weight-bold">
                      <v-img
                        contain
                        max-height="50"
                        max-width="70"
                        :src="require('@/assets/logos/stitch.webp')"
                        :lazy-src="require('@/assets/logos/stitch.webp')"
                      />
                      LinkPay (recommended)
                      <v-icon
                        small
                        @click="linkVerifyInfoClicked = !linkVerifyInfoClicked"
                        >mdi-information</v-icon
                      ></span
                    >
                    <br />
                    Automatic Verification and Payment with Stitch
                    <span
                      class="caption font-weight-medium"
                      v-if="linkVerifyInfoClicked"
                    >
                      <br />
                      This links your account by adding Strapp as a beneficiary
                      <br />
                      and will enable ease of payment going forward <br />
                    </span>
                    <br v-if="!linkVerifyInfoClicked" />
                    <span class="caption red--text"
                      >Capitec not currently supported
                    </span>
                  </p>
                </template></v-radio
              >
            </v-card>
            <v-card class="pa-4 ma-4 mt-n2" outlined>
              <v-radio label="Manual Payment and Verification" value="manual">
                <template v-slot:label>
                  <div>
                    <p class="caption">
                      <strong class="body-2 font-weight-bold">
                        Manual Payment and Verification
                        <v-icon
                          small
                          @click="
                            manualVerifyInfoClicked = !manualVerifyInfoClicked
                          "
                          >mdi-information</v-icon
                        >
                        <br />
                      </strong>
                      Manual Payment via payfast link email
                      <span v-if="manualVerifyInfoClicked"
                        ><br />This will allow you to upload your verification
                        documents manually <br />and then you will receive a
                        payfast payment link via email.</span
                      >
                      <br />
                    </p>
                  </div> </template
              ></v-radio>
            </v-card>
          </v-radio-group>
          <hr />
        </div>
        <v-card-actions class="mt-n6">
          <v-btn
            large
            color="blue darken-1"
            text
            @click="closeVerifyPaychoiceDialog()"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            large
            color="accent darken-1"
            :loading="loading"
            text
            @click="NextVerify()"
          >
            Verify & Pay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            We have recieved your payment!. You are now free to discuss delivery
            or collection with the borrower.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  @click="refresh()"
                  color="accent"
                >
                  Continue
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>



<style>
.grid {
  place-items: center;
  display: grid;
}
</style>
